<template>
  <div class="card card-box">
    <div class="card-body p-5">
      <!-- Image Profile -->
      <div class="row">
        <div class="col-md-12">
          <h6 class="text-center mb-2">Profil Dokter</h6>
          <div class="profile d-flex justify-content-center">
            <div class="profile-custom">
              <img :src="imgURL" alt="" srcset="" />
              <div
                class="delete_photo"
                v-if="
                  this.imgURL !== '/img/hospital.png' &&
                    this.imgURL !== '/img/doctor.png' &&
                    imgURL !== null
                "
                @mouseover="isDropPhoto = true"
                @mouseleave="isDropPhoto = false"
                @click="deletePhoto()"
              >
                <font-awesome-icon
                  class="icon-times"
                  v-show="isDropPhoto"
                  icon="times"
                />
              </div>
              <b-button
                class="__btn_add_photo"
                type="file"
                @click="$refs.pictureInput.onClick()"
                ><font-awesome-icon
                  icon="camera"
                  class="text-white-50 __icon_add_photo"
              /></b-button>
            </div>
            <template>
              <picture-input
                style="display:none"
                class="inputPhoto"
                ref="pictureInput"
                :disabled="btnDisable == true"
                :customStrings="{
                  fileSize: 'File maksimal foto 1 mb',
                  fileType: 'Jenis file ini tidak didukung'
                }"
                :alertOnError="false"
                :zIndex="1"
                size="2"
                width="130"
                height="125"
                radius="50"
                :hideChangeButton="true"
                @change="onChangeImage($event)"
                :prefill="imgURL"
              />
            </template>
          </div>
          <h5 class="font-weight-bold text-center mt-2">
            {{ oldName }}
          </h5>
          <p class="text-right" style="font-size: 10pt; color: #5d5d5d;">
            Foto yang diunggah maksimal 2Mb. <br />
            dengan format file antara lain PNG, JPG, dan JPEG
          </p>
        </div>
      </div>
      <!-- End Image Profile -->

      <!-- Infor Profile -->
      <div class="row">
        <div class="col-md-6">
          <b-form-group>
            <label for="">Nama Dokter<span style="color:red">*</span></label>
            <b-form-input
              :disabled="!btnDisable"
              type="text"
              maxlength="50"
              v-model="formProfile.nameDokter"
              @input="inputNameDokter($event)"
            ></b-form-input>
            <span
              style="color:red"
              v-if="formProfile.errors.nameDokter.message"
            >
              {{ formProfile.errors.nameDokter.message }}
            </span>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group>
            <label for="">No. SIP<span style="color:red">*</span></label>
            <b-form-input
              :disabled="!btnDisable"
              type="text"
              v-model="formProfile.noSip"
              @input="inputNoSip($event)"
            ></b-form-input>
            <span style="color:red" v-if="formProfile.errors.noSip.message">
              {{ formProfile.errors.noSip.message }}
            </span>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <b-form-group>
            <label for="">No. Handphone<span style="color:red">*</span></label>
            <b-form-input
              :disabled="!btnDisable"
              type="text"
              maxlength="50"
              v-model="formProfile.handphone"
              @keypress="keypressHandphone($event)"
              @input="inputHandphone($event)"
            ></b-form-input>
            <span style="color:red" v-if="formProfile.errors.handphone.message">
              {{ formProfile.errors.handphone.message }}
            </span>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group>
            <label for=""
              >Masa Berlaku SIP<span style="color:red">*</span></label
            >
            <DatePickerX
              v-model="formProfile.masaSip"
              :popover="{
                placement: 'left-end',
                visibility: 'click'
              }"
              :input-props="{ placeholder: 'Pilih Tanggal', readonly: true }"
              :masks="{ input: 'DD-MM-YYYY' }"
              :is-required="true"
            >
              <template v-slot="{ inputValue, togglePopover }">
                <div class="flex items-center">
                  <b-input-group>
                    <b-form-input
                      :disabled="!btnDisable"
                      type="text"
                      :value="inputValue"
                      @click="togglePopover()"
                      @input="inputMasaSip($event)"
                    ></b-form-input>

                    <b-input-group-append>
                      <b-button
                        class="btn-calander"
                        :disabled="!btnDisable"
                        variant="secondary"
                        @click="togglePopover()"
                      >
                        <font-awesome-icon
                          class="icon-calendar"
                          icon="calendar"
                        />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </template>
            </DatePickerX>
            <span style="color:red" v-if="formProfile.errors.masaSip.message">
              {{ formProfile.errors.masaSip.message }}
            </span>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <b-form-group>
                <label for="">Email<span style="color:red">*</span></label>
                <b-form-input
                  :disabled="!btnDisable"
                  type="text"
                  maxlength="50"
                  v-model="formProfile.email"
                  @input="inputEmail($event)"
                ></b-form-input>
                <span style="color:red" v-if="formProfile.errors.email.message">
                  {{ formProfile.errors.email.message }}
                </span>
              </b-form-group>
            </div>
            <div class="col-md-12">
              <b-form-group>
                <label for=""
                  >Spesialisasi<span style="color:red">*</span></label
                >
                <vue-select
                  style="font-size:13px"
                  :options="optionsSpesialisasi"
                  v-model="formProfile.spesialisasi"
                  placeholder="Spesialisasi"
                  @input="inputSpesialisasi($event)"
                  :disabled="!btnDisable"
                />
                <span
                  style="color:red"
                  v-if="formProfile.errors.spesialisasi.message"
                >
                  {{ formProfile.errors.spesialisasi.message }}
                </span>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <b-form-group>
                <label for="">Upload SIP</label>
                <div
                  class="sip-file d-flex flex-column justify-content-center text-center"
                  :class="{
                    'bg-disable': !btnDisable,
                    'bg-enable': btnDisable
                  }"
                  @click="btnDisable ? $refs.inputSipFile.click() : () => {}"
                >
                  <div>
                    <font-awesome-icon
                      class="icon-file-upload fa-2x"
                      icon="file-upload"
                    />
                  </div>
                  <div class="mt-2">
                    Format yang diizinkan jpeg, jpg, png, pdf, maks 2 MB.
                  </div>
                </div>
                <!-- <picture-input
                  ref="sipFile"
                  style="display:none"
                  :disabled="btnDisable == true"
                  :customStrings="{
                    fileSize: 'File maksimal foto 2 mb',
                    fileType: 'Jenis file ini tidak didukung'
                  }"
                  :alertOnError="false"
                  :zIndex="1"
                  size="2"
                  width="130"
                  height="125"
                  radius="50"
                  :hideChangeButton="true"
                  @change="onChangeSipFile($event)"
                  :prefill="imgURL"
                /> -->
                <input
                  type="file"
                  accept="image/*,.pdf"
                  @click="resetFileInput"
                  style="display:none"
                  ref="inputSipFile"
                  @change="onChangeSipFile($event)"
                />
                <span
                  style="color:red"
                  v-if="formProfile.errors.sipFile.message"
                >
                  {{ formProfile.errors.sipFile.message }}
                </span>
              </b-form-group>
            </div>
            <div class="col-md-12 v-tooltip">
              <div
                v-for="(item, index) in selectedFiles"
                :key="index"
                class="row file-upload"
              >
                <div class="col-md-5">
                  <label
                    class="text-break"
                    v-if="item.name.length > 10"
                    v-tooltip="{
                      content: item.name,
                      classes: 'schedule-tooltip',
                      trigger: 'hover'
                    }"
                    >{{ item.name.slice(0, 10) + "..." }}</label
                  >

                  <label class="text-break" v-else>{{ item.name }}</label>
                </div>
                <div class="col-md-3">
                  <label>{{ item.size / 1000 }} KB</label>
                </div>
                <div class="col-md-4">
                  <div class="row d-flex mr-2">
                    <!-- :href="item.url" -->
                    <!-- <a
                      @click.prevent="donwloadImage(item)"
                      v-if="item.from_api"
                    >
                      <font-awesome-icon
                        icon="download"
                        class="font-size-xl grow icon"
                        style="margin-right:20px"
                      />
                    </a> -->
                    <a @click="donwloadImage(item)">
                      <template v-if="!downloadSip">
                        <font-awesome-icon
                          icon="download"
                          class="font-size-xl grow icon"
                          style="margin-right:20px"
                        />
                      </template>
                      <template v-else>
                        Downloading...
                      </template>
                    </a>
                    <font-awesome-icon
                      icon="eye"
                      class="font-size-xl grow icon"
                      style="margin-right:20px"
                      @click="readFile(item)"
                    />
                    <template v-if="!btnDisable">
                      <font-awesome-icon
                        icon="trash"
                        class="font-size-xl grow icon"
                      />
                    </template>
                    <template v-else>
                      <font-awesome-icon
                        icon="trash"
                        style="cursor:pointer"
                        class="font-size-xl grow icon"
                        @click="removeFile(item, index)"
                      />
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12 mb-3">
          <b-button
            variant="primary"
            v-if="btnDisable"
            class="float-right"
            @click="onSubmit"
            >SIMPAN DATA</b-button
          >
          <b-button
            variant="primary"
            v-if="!btnDisable"
            @click="btnDisable = true"
            class="float-right"
            >EDIT DATA</b-button
          >
        </div>
      </div>
      <!-- End Info Profile -->
    </div>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import axios from "axios";
import { mapGetters } from "vuex";
import { counter, library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfo,
  faFolder,
  faCamera,
  faTimes,
  faCalendar,
  faFileUpload,
  faDownload,
  faTrash,
  faEye
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faInfo,
  faCamera,
  faFolder,
  faTimes,
  faCalendar,
  faFileUpload,
  faDownload,
  faTrash,
  faEye
);
import { EventBus } from "../../../event-bus";

import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import moment from "moment";
locale.use(lang);

export default {
  components: {
    PictureInput,
    "vue-select": () => import("@/components/VueSelect.vue"),
    DatePickerX: () => import("v-calendar/lib/components/date-picker.umd")
  },
  data() {
    return {
      imgURL: "",
      activeTab: "profile",
      isDropPhoto: null,
      btnDisable: false,
      cities: [],
      provinces: [],
      downloadSip: false,

      optionsJenisFaskes: [
        { value: 1, label: "Klinik" },
        { value: 2, label: "Dokter Praktik Mandiri" }
      ],

      optionsSpesialisasi: [],

      formProfile: {
        nameDokter: "",
        spesialisasi: "",
        handphone: "",
        masaSip: "",
        noSip: "",
        email: "",
        sipFile: "",
        errors: null
      },
      oldEmail: null,
      oldName: null,
      oldSip: null,
      dokterId: "",
      marginTop: "-100px",
      selectedFiles: [],
      firstLoad: true
    };
  },
  created() {
    // this.getCities();
    this.getSpesialisasi();
    this.getProfile();
    this.buildErrorMessage();
  },
  mounted() {
    if (this.$refs.pictureInput.file != undefined) {
      this.isDefault = false;
    }

    window.swal = this.$swal;
    const inputFiles = document.querySelector(".inputPhoto").childNodes[1];

    inputFiles.addEventListener("change", () => {
      const imgFile = inputFiles.files[0];

      const allowedImg = ["jpeg", "jpg", "png"];
      const imgType = imgFile.name.split(".").slice(-1)[0];

      if (!allowedImg.includes(imgType.toLowerCase())) {
        window.swal({
          type: "warning",
          title: "Foto Gagal Disimpan",
          text: "Foto yang Diunggah Tidak Sesuai Format.",
          width: "800px",
          allowOutsideClick: false
        });
        return;
      }

      if (imgFile.size > 2097152) {
        window.swal({
          type: "warning",
          title: "Foto Gagal Disimpan",
          text: "Maksimal Ukuran Gambar 2 MB!",
          width: "800px",
          allowOutsideClick: false
        });
        return;
      }

      // this.onChangeSipFile();
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName", "getFaskesType"]),
    isPic() {
      return /pic/.test(this.getRolesName);
    },
    isDokter() {
      const condition1 = /dokter/.test(this.getRolesName);

      return condition1;
    },
    isDpm() {
      return this.getFaskesType;
    },
    periodSip() {
      return this.formProfile.masaSip;
    }
  },
  watch: {
    periodSip: function(val, oldVal) {
      if (val && !this.firstLoad) {
        this.inputMasaSip(val);
      }
      this.firstLoad = false;
    }
  },
  methods: {
    buildErrorMessage() {
      this.formProfile.errors = {
        status: false,
        nameDokter: {
          error: false,
          message: ""
        },
        spesialisasi: {
          error: false,
          message: ""
        },
        handphone: {
          error: false,
          message: ""
        },
        masaSip: {
          error: false,
          message: ""
        },
        noSip: {
          error: false,
          message: ""
        },
        email: {
          error: false,
          message: ""
        },
        sipFile: {
          error: false,
          message: ""
        }
      };
    },
    selectTab(menu) {
      this.activeTab = menu;
    },
    async getSpesialisasi() {
      try {
        const res = await axios.get(`${this.url_api}/spesialisasi`);
        const { data } = res.data;
        this.optionsSpesialisasi = data.spesialisasi.map(item => {
          return {
            value: item.id,
            label: item.nama
          };
        });
      } catch (error) {}
    },

    async getProfile() {
      try {
        let profile;
        this.imgURL = "";
        this.selectedFiles = [];

        profile = this.$store.state.user.id;

        const res = await axios.get(
          `${this.url_api}/klinik/user/${profile}?klinik_id=${this.getKlinikId}`
        );

        const { data } = res.data;
        const klinik = data.klinik_user[0].klinik;
        const dokter = data.dokter[0];
        const name = dokter.nama;

        let noSip = dokter.nomor_sip;

        this.oldSip = noSip;

        this.formProfile = {
          ...this.formProfile,
          nameDokter: name,
          noSip,
          spesialisasi: this.optionsSpesialisasi.find(
            item => item.value == dokter.spesialisasi_id
          ),
          email: data.email,
          handphone: data.nomor_telp,
          masaSip: dokter.masa_berlaku_sip
            ? moment(dokter.masa_berlaku_sip).format("YYYY-MM-DD")
            : "",
          alamat: klinik.alamat
        };
        this.oldEmail = data.email;
        this.oldHandphone = data.nomor_telp;
        this.oldName = name;
        this.dokterId = dokter.id;

        if (dokter.nomor_sip_file)
          this.selectedFiles.push(JSON.parse(dokter.nomor_sip_file));

        if (data.foto_profile == null) {
          this.imgURL = "/img/doctor.png";
        } else {
          this.imgURL = data.foto_profile;
        }

        EventBus.$emit("count-schedule", 0);
      } catch (error) {
        // console.log(error);
      }
    },
    hasFeatures(value) {
      const features = {
        manajemen: ["owner_klinik", "manajemen"],
        klinik: ["pic_cabang", "pic_pusat"],
        dokter: ["dokter_klinik"]
      };
      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return isOwner.length > 0 ? true : false;
    },
    errorImagePopUp(message) {
      this.$swal({
        type: "warning",
        title: "Foto Gagal Disimpan",
        text: message,
        width: "800px",
        allowOutsideClick: false
      });
      this.$refs.pictureInput.file = null;
      this.$refs.pictureInput.image = null;
      this.$refs.pictureInput.fileModified = null;
      this.$refs.pictureInput.fileName = null;
      this.$refs.pictureInput.fileSize = null;
      this.$refs.pictureInput.fileType = null;
    },
    errorSipPopUp(message) {
      this.$swal({
        type: "warning",
        title: "Gagal Disimpan",
        text: message,
        width: "800px",
        allowOutsideClick: false
      });
    },
    onChangeImage(image) {
      let formData = new FormData();
      let imgFile = this.$refs.pictureInput.file;

      const allowedImg = ["jpeg", "jpg", "png"];
      const imgType = imgFile.name.split(".").slice(-1)[0];

      if (!allowedImg.includes(imgType.toLowerCase())) {
        this.errorImagePopUp("File yang Diunggah Tidak Sesuai Format");
        return;
      }

      if (imgFile.size > 2097152) {
        this.errorImagePopUp("Maksimal Ukuran Gambar 2 MB!");
        return;
      }

      formData.append("klinik_id", this.getKlinikId);
      formData.append("file", this.$refs.pictureInput.file);
      formData.append("type", "user");

      if (image) {
        const profile = this.$store.state.user.id;

        axios
          .post(`${this.url_api}/klinik/upload/photo/${profile}`, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(respononse => {
            this.$swal({
              type: "success",
              title: "Update Foto Profil Berhasil",
              text: "Foto Profil Berhasil Disimpan",
              allowOutsideClick: false
            });
            this.imgURL = respononse.data.data.url;
            this.isDropPhoto = false;
            EventBus.$emit("image-uploaded", true);
          });
      }
    },
  
    deletePhoto() {
      try {
        let formData = new FormData(),
          profile = this.$store.state.user.id;

        formData.append("klinik_id", this.getKlinikId);
        formData.append("type", "user");

        axios
          .post(`${this.url_api}/klinik/delete-photo/${profile}`, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(() => {
            this.imgURL = "/img/doctor.png";

            EventBus.$emit("image-uploaded", true);
          });
      } catch (error) {
        // console.log(error)
      }
    },
    inputProvinsi(province) {
      this.getCityByProvince(province);
      this.formProfile.provinsiId = province.id;
    },
    inputKabupaten(city) {
      this.formProfile = {
        ...this.formProfile,
        kabupaten: city
      };

      this.formProfile.kabupatenId = city.id;
    },
    inputSpesialisasi(type) {
      this.removeErrorField("spesialisasi");

      if (!type.value) {
        this.addErrorField("spesialisasi", `Spesialisasi harus diisi`);
        return;
      }

      this.formProfile = {
        ...this.formProfile,
        spesialisasi: type
      };

      this.formProfile.spesialisasi_id = type.value;
    },
    inputEmail(value) {
      this.removeErrorField("email");

      if (!value) {
        this.addErrorField("email", `Email harus diisi`);
        return;
      }

      if (
        value.match(
          /^([A-Za-z][A-Za-z0-9\-\.\_\+]*)\@([A-Za-z][A-Za-z0-9\-\_\+]*)(\.[A-Za-z][A-Za-z0-9\-\_\+]*)+$/
        ) == null
      ) {
        this.addErrorField("email", "Format email salah");
        return;
      } else {
        this.removeErrorField("email");
      }

      if (value == this.oldEmail) return;

      if (this._timeoutEmail) clearTimeout(this._timeoutEmail);

      this._timeoutEmail = setTimeout(() => {
        axios
          .get(`${this.url_api}/email/verify?tipe_faskes=1&email=${value}`)
          .then(response => {
            if (response.data.status == false) {
              this.addErrorField("email", "Email sudah digunakan");
            } else {
              this.removeErrorField("email");
            }
          })
          .catch(error => {})
          .finally(() => {
            clearTimeout(this._timeoutEmail);
          });
      }, 600);
    },
    keypressHandphone(evt) {
      evt = evt ? evt : window.event;

      if (evt.target.value.length > 14) {
        evt.preventDefault();
      }

      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    inputHandphone(value) {
      this.removeErrorField("handphone");

      if (!value) {
        this.addErrorField("handphone", `No. Handphone harus diisi`);
        return;
      }

      if (value.length <= 8 || value.length > 15) {
        this.addErrorField("handphone", "No. Handphone Minimal 9 Karakter");
        return;
      } else {
        this.removeErrorField("handphone");
      }

      if (value == this.oldHandphone) return;

      if (this._timeoutEmail) clearTimeout(this._timeoutEmail);

      this._timeoutEmail = setTimeout(() => {
        axios
          .get(`${this.url_api}/phone/verify?tipe_faskes=1&nomor_telp=${value}`)
          .then(response => {
            if (response.data.status == false) {
              this.addErrorField("handphone", "No.Handphone telah terdaftar");
            } else {
              this.removeErrorField("handphone");
            }
          })
          .catch(error => {})
          .finally(() => {
            clearTimeout(this._timeoutEmail);
          });
      }, 600);
    },

    inputMasaSip(value) {
      let val = value;

      this.removeErrorField("masaSip");

      if (!val) {
        this.addErrorField("masaSip", `Masa berlaku SIP harus diisi`);
        return;
      }

      if (val instanceof Date) {
        val = moment(val).format("DD-MM-YYYY") + "";
      }

      const regexPeriod1 = /^\d{2}-\d{2}-\d{4}$/;
      const regexPeriod2 = /^\d{4}-\d{2}-\d{2}$/;
      let period = "",
        periodDate = "";

      if (val.match(regexPeriod1)) {
        period = moment(val, "DD-MM-YYYY").format("YYYY-MM-DD");
      } else if (val.match(regexPeriod2)) {
        period = moment(val, "YYYY-MM-DD").format("YYYY-MM-DD");
      } else {
        this.addErrorField(
          "masaSip",
          `Masa berlaku SIP harus diisi harus DD-MM-YYYY`
        );
        return;
      }

      periodDate = moment(period, "YYYY-MM-DD");

      if (periodDate.isValid()) {
        this.removeErrorField("masaSip");
      }

      this.firstLoad = false;
    },
    inputNameDokter(value) {
      this.removeErrorField("nameDokter");
      if (!value) {
        this.addErrorField("nameDokter", `Nama Dokter harus diisi`);
        return;
      }
    },
    inputAlamat(value) {
      this.removeErrorField("alamat");
      // if (!value) {
      //   this.addErrorField("alamat", `Alamat harus diisi`);
      //   return;
      // }
    },
    inputNoSip(value) {
      this.removeErrorField("noSip");

      if (!value) {
        this.addErrorField("noSip", `No. SIP harus diisi`);
        return;
      }

      if (value == this.oldSip) return;

      // if (this._timeoutEmail) clearTimeout(this._timeoutEmail);

      // const pathDpm = `klinik/dokter/sip/cek?klinik_id=${this.getKlinikId}&sip=${value}&is_dpm=true`;
      // const pathKlinik = `klinik/no_izin/cek?no_izin=${value}`;

      // const axiostHttp = axios.post(`${this.url_api}/${pathDpm}`);

      // this._timeoutEmail = setTimeout(() => {
      //   axiostHttp
      //     .then(response => {
      //       if (response.data.status == false) {
      //         this.addErrorField("noSip", `No. SIP sudah digunakan`);
      //       } else {
      //         this.removeErrorField("noSip");
      //       }
      //     })
      //     .catch(error => {})
      //     .finally(() => {
      //       clearTimeout(this._timeoutEmail);
      //     });
      // }, 600);
    },

    addErrorField(field, message) {
      this.formProfile.errors.status = true;
      this.formProfile.errors[field] = {
        error: true,
        message
      };
    },
    removeErrorField(field) {
      this.formProfile.errors[field] = {
        error: false,
        message: ""
      };
    },
    requiredValidation() {
      const field = [
        "nameDokter",
        "handphone",
        "spesialisasi",
        "noSip",
        "email",
        "masaSip"
      ];
      const fieldLabel = [
        "Nama Faskes",
        "No. Telp Faskes",
        "Spesialisasi",
        "No. SIP",
        "email",
        "Masa berlaku SIP"
      ];

      for (const [index, attr] of field.entries()) {
        if (!this.formProfile[attr]) {
          this.addErrorField(attr, `${fieldLabel[index]} harus diisi`);
        }
      }
    },
    errorExist() {
      const errors = Object.assign({}, this.formProfile.errors);
      delete errors.status;

      for (const attr in errors) {
        if (errors[attr].message) {
          return true;
        }
      }
    },
    onSubmit() {
      this.requiredValidation();

      if (this.errorExist()) {
        return;
      }

      let payload = {
        ...this.formProfile,
        name: this.formProfile.nameDokter,
        oldEmail: this.oldEmail,
        klinik_id: this.getKlinikId,
        user_id: this.$store.state.user.id,
        dokter_id: this.dokterId,
        spesialisasi_id: this.formProfile.spesialisasi.value,
        masaSip: moment(this.formProfile.masaSip).format("YYYY-MM-DD"),
        isDokter: this.isDokter,
        isDpm: this.isDpm
      };

      const isEmailSame = payload.email ? this.oldEmail == payload.email : true;

      const sipFile = this.selectedFiles.length > 0 ? this.selectedFiles[0] : ''

      if(sipFile) {
        if (Object(sipFile).hasOwnProperty("fileBlob")) {
          this.uploadSipFile(sipFile.file)
        }
      }

      axios
        .post(`${this.url_api}/klinik/profile/user`, payload)
        .then(response => {
          if (!isEmailSame)
            this.$store.commit(
              "SET_VERIFICATION_PROFILE_ID",
              response.data.data.id
            );

          if (response.data.status) {
            this.$swal({
              type: "success",
              title: "Update Data Informasi Berhasil",
              text: "Data Informasi Berhasil Disimpan",
              width: "700px",
              allowOutsideClick: false
            }).then(result => {
              if (result.value) {
                if (isEmailSame) {
                  EventBus.$emit("image-uploaded", true);
                  this.btnDisable = false;
                  this.getProfile();
                  // this.$router.push({ name: "account-setting" });
                } else {
                  this.$router.push({
                    name: "account-setting-verification-code"
                  });
                }
              }
            });
          } else {
            throw new Error("failed");
          }
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Simpan Data Informasi Pengguna",
            text: "Simpan Data Informasi Pengguna Gagal",
            width: "700px"
          });
        });
    },
    getFileName(file) {
      let filename = file.name;
      filename = filename.split(" ").join("_");
      filename = filename.split(".").join("_");

      return filename;
    },
    onChangeSipFile(event) {
      this.selectedFiles = [];

      let imgFile = event.target.files[0];
      let filename = this.getFileName(imgFile);

      const allowedImg = ["jpeg", "jpg", "png", "pdf"];
      const imgType = imgFile.name.split(".").slice(-1)[0];

      if (!allowedImg.includes(imgType.toLowerCase())) {
        this.errorSipPopUp("File yang Diunggah Tidak Sesuai Format");
        return;
      }

      if (imgFile.size > 2097152) {
        this.errorSipPopUp("Maksimal Ukuran File 2 MB!");
        return;
      }

      let reader = new FileReader();
      let metaFile = {
        name: filename,
        size: imgFile.size,
        file: imgFile,
        fileBlob: ""
      };

      reader.onload = event => {
        let result = event.target.result;
        let block = result.split(";");
        let contentType = block[0].split(":")[1];
        let realData = block[1].split(",")[1];
        let blob = this.b64toBlob(realData, contentType);
        metaFile.fileBlob = blob;
      };

      reader.readAsDataURL(imgFile);

      this.selectedFiles.push(metaFile);

      // let objUrl = URL.createObjectURL(metaFile.file)
    },

    uploadSipFile(imgFile) {
      let formData = new FormData();
      let filename = this.getFileName(imgFile);

      formData.append("file", imgFile);
      formData.append("filename", filename);
      formData.append("type", "dokter");

      if (imgFile) {
        const profile = this.dokterId;
        axios
          .post(`${this.url_api}/klinik/upload/sip/${profile}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              // let progress =
              //   (progressEvent.loaded * 100) / progressEvent.total;
              // this.$set(this.fileProgress, filename, progress);
            }
          })
          .then(res => {
            // this.$swal({
            //   type: "success",
            //   title: "Update SIP Berhasil",
            //   text: "SIP Berhasil disimpan",
            //   allowOutsideClick: false
            // });
            // if (res.data.status) this.uploadedFiles.push(res.data);
          })
          .catch(e => {});
      }
    },

    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },

    async donwloadImage(item) {
      this.downloadSip = true;
      let sourceFile = "";
      if (Object(item).hasOwnProperty("fileBlob")) {
        sourceFile = URL.createObjectURL(item.fileBlob);
        this.downloadSip = false;
      } else {
        sourceFile = await this.toDataURL(item.url);
      }

      const a = document.createElement("a");

      a.href = sourceFile;
      a.download = item.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    toDataURL(url) {
      return fetch(url)
        .then(response => {
          return response.blob();
        })
        .then(blob => {
          return URL.createObjectURL(blob);
        })
        .finally(() => {
          this.downloadSip = false;
        });
    },
    //view selected file
    readFile(item) {
      let sourceFile = "";
      if (Object(item).hasOwnProperty("fileBlob")) {
        let sourceFile = (URL.createObjectURL(item.fileBlob));
        window.open(sourceFile, "_blank");
      } else if (item.url) {
        window.open(item.url, "_blank");
      } else {
        this.$swal({
          type: "warning",
          title: "Preview File Gagal",
          text: "File Tidak Ditemukan",
          width: "800px"
        });
      }
    },
     //remove selected file
     removeFile(item, index) {
      if (Object(item).hasOwnProperty("fileBlob")) {
        this.selectedFiles = [];
        return;
      }

      let profile = this.dokterId;

      axios
        .post(`${this.url_api}/klinik/delete-sip/${profile}`, {
          type: "dokter"
        })
        .then(response => {
          this.getProfile();
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Gagal Hapus Data",
            text: "File Tidak Ditemukan",
            width: "800px"
          });
        });
    },
    resetFileInput() {
      const x = this.$refs.inputSipFile;
      x.value = "";
    }
  }
};
</script>
<style>
#faskesProfile {
  transform: scale(0.78);
  width: 128%;
  margin-left: -14%;
  /* margin-top: -100px; */
  font-size: 12pt;
}

.v-tooltip .tooltip-inner {
  background: #ffffff !important;
  color: #858585 !important;
}

.v-tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #ffffff;
  z-index: 1;
}
</style>
<style scoped>
.__blue {
  color: #4b80b6;
}
.__icon_add_photo {
  position: absolute;
  top: 12px;
  left: 14px;
}
.__btn_add_photo {
  position: absolute;
  top: 85px;
  right: -20px;
  z-index: 20;
  border-radius: 50%;
  height: 44px !important;
  background-color: rgb(121, 121, 121);
}
.delete_photo {
  position: absolute;
  width: 100%;
  height: 20%;
  top: 30%;
  z-index: 9;
  font-size: 30pt;
  text-align: center;
}
.profile-custom {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  position: relative;
  border: 1px solid #cdcdcd;
}

.profile-custom img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.bg-disable {
  background: #eeeff8;
}

.bg-enable {
  background: #ffffff;
}

.sip-file {
  height: 130px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #cdcdcd;
}

.btn-calander {
  box-shadow: none;
}
</style>
